// lib
import React from 'react'

// components
import PageTitle from 'src/components/header/main/page_title/page_title'

// helpers
import { ContentItemQuery } from '@lopo-tech/lopo-api'
import { textResources } from 'src/lang/de'
import { useGetAppLocationShape } from 'src/reducers/app-state/app-state_hooks'

interface IProps {
  contentItem: ContentItemQuery['contentItem']
}

const { eventfeed, newsfeed } = textResources.pageTitles

const PageTitleDetailsPage: React.FC<IProps> = ({ contentItem }) => {
  const locationShape = useGetAppLocationShape()
  const isEvent = contentItem?.__typename === 'Event'
  const titleText = isEvent ? eventfeed : newsfeed

  const postLocationShape = contentItem?.address?.locationShape

  return (
    <PageTitle
      isHome={postLocationShape?.name === locationShape?.name}
      text={titleText}
      location={postLocationShape?.name}
      showLocation={true}
      customTag='p'
    />
  )
}

export default PageTitleDetailsPage
